import {Grid} from "@mui/material";
import React, {useEffect} from "react";
import {SosDonationProduct} from "../../../../packages/graphql-layer/src";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import C085ProductTeaser from "./C085ProductTeaser";

export interface Props {
    items: SosDonationProduct[],
    isPageView?: boolean,
    isFull? : boolean,
    suppressRoofline?: boolean
}

const DESCRIPTION_CHAR_LIMIT = 1200;
/**
 * Rendert die einzelTeaserdarstellung eines Produktes (ohne Suchliste oder Collection)
 */
function C085ProductTeaserContainer(props: Props) {
    useEffect(() => {
        // Deaktiviert die automatische Scroll-Wiederherstellung des Browsers.
        // Verhindert Scroll-Sprünge beim Zurück-Navigieren, da der Browser sonst die Scrollposition zu früh wiederherstellt.
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    const charLimit = props.suppressRoofline ? DESCRIPTION_CHAR_LIMIT : undefined;
    if (props.items != null) {
        return <CCOComponentWrapper noBottomMargin={props.isPageView} background="grey" noTopMargin={props.suppressRoofline}>
            <CCOContainer background="grey" width={props.isFull ? "full" : "large"} marginBottom={0}>
                <CCOContainer width={"large"} marginBottom={6} marginTop={6}>
                    <Grid container spacing={4}>
                        {props.items.map((item: any) => {
                            return <C085ProductTeaser key={"itemp-"+item.id} 
                                        item={item} 
                                        itemCount={props.items.length} 
                                        isPageView={props.isPageView}
                                        suppressRoofline={props.suppressRoofline}
                                        descriptionCharLimit={charLimit}  />
                        })}
                    </Grid>
                </CCOContainer>
            </CCOContainer>
        </CCOComponentWrapper>
    } else {
        return null
    }
}

export default C085ProductTeaserContainer